import React from "react";
import { Link } from "react-router-dom";

// (Components)
import Spacer from "./Spacer";

const Footer = () => {
  return (
    <footer className="w-full bg-transparent shadow-sm">
      <Spacer>
        <div className="w-full py-6 flex gap-10 items-center">
          <Link to="#">
            <p className="font-light text-base opacity-65">Terms & conditon</p>
          </Link>

          <Link to="#">
            <p className="font-light text-base opacity-65">Privacy Policy</p>
          </Link>
        </div>
      </Spacer>
    </footer>
  );
};

export default Footer;
